window.jQuery = window.$ = require('jquery');
var processInclude = require('./util');
var LazyLoad = require('vanilla-lazyload');

$(document).ready(function () {
    processInclude(require('./components/menu'));
    processInclude(require('./components/cookie'));
    processInclude(require('./components/footer'));
    processInclude(require('./components/miniCart'));
    processInclude(require('./components/search'));
    processInclude(require('./components/clientSideValidation'));
    processInclude(require('./components/toolTip'));
    processInclude(require('./ah-carousel'));
    processInclude(require('./components/betaMode'));
    processInclude(require('./components/validateImage'));
    processInclude(require('./components/collapsibleItem'));
    processInclude(require('./components/observers.js'));
    processInclude(require('./checkout/loginAccountModal'));
    processInclude(require('./crossDomainRecookie'));
    processInclude(require('./search/search'));
    processInclude(require('./product/quickView'));
    processInclude(require('./experience/reusableComponents.js'));
    var lazyLoadInstance = new LazyLoad({
        unobserve_entered: true, // Avoid infinite loop execution
    });
    window.lazyLoadInstance = lazyLoadInstance;
});

require('./thirdParty/bootstrap');
require('./components/spinner');
require('bootstrap-select/js/bootstrap-select');
require('./thirdParty/slick');
require('./thirdParty/bootstrap-drawer');
require('./thirdParty/jquery.zoom');